module.exports = __webpack_public_path__ + "static/media/left-round-gray.f1a7195a.svg";